
export default {
  desktopPlane: require('./desktopPlane.svg'),
  faceBookIcon: require('./social-fb.svg'),
  twitterIcon: require('./social-twitter.svg'),
  youTubeIcon: require('./social-youtube.svg'),
  instaIcon: require('./social-insta.svg'),
  personal: require('./personal-area.svg'),
};
